import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from '@ionic/angular';

import { AddToCartDto } from '../../generate-client/model/addToCartDto';
import { CartService } from '../../generate-client/api/cart.service';
import { LocalStorageService } from 'src/app/services/local-storage-service.service';
import { environment } from 'src/environments/environment';
import { ItemGetOneDto } from 'src/app/generate-client/model/itemGetOneDto';
import { CartQantityService } from 'src/app/services/cart.service';
import { SignalRService } from 'src/app/services/signal-r.service';
import { ExtrasDto, OptionalForItemDto } from 'src/app/generate-client';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
})

export class ItemComponent implements OnInit {

  item: ItemGetOneDto;
  idStore: number;
  quantity: number = 1;
  priceSizeSelected: string = '1';
  addons: any = {};
  loading: HTMLIonLoadingElement;
  hubConnection: signalR.HubConnection;

  constructor(
    public navParams: NavParams,
    private _cartService: CartService,
    private modalController: ModalController,
    public toastController: ToastController,
    public loadingController: LoadingController,
    private nav: NavController,
    private localStorageService: LocalStorageService,
    private _cartQantityService: CartQantityService,
    private _signalRService: SignalRService
  ) { }

  ngOnInit() {
    this.item = this.navParams.get('item');
    this.idStore = this.localStorageService.getRestaurantData().cdStore;
    this.InitializeSignalR();
  }

  public async ionViewDidLeave(): Promise<void> {
    await this.closeSignalR();
  }

  private InitializeSignalR(): void {

    this._signalRService.startConnectionWithProducts();

    this._signalRService.addToGroupWithStart(String(this.idStore));

    this.hubConnection = this._signalRService.getHubConnection();

    this.hubConnection.on("UpdatedProducts", () => {
      location.reload();
    });
  }

  private async closeSignalR() {
    await this.hubConnection.stop();
  }

  addquantity() {
    this.quantity += 1
  }

  subtractQantity() {
    if (this.quantity)
      this.quantity -= 1
  }

  public getPrices() {

    let price = 0;

    switch (this.priceSizeSelected) {
      case '0':
        price = this.item.qtDiscountedSmallPrice?? this.item.qtSmallPrice;
        break;

      case '1':
        price = this.item.qtDiscountedMediumPrice ?? this.item.qtMediumPrice;
        break;

      case '2':
        price = this.item.qtDiscountedLargePrice ?? this.item.qtLargePrice;
        break;

      default:
        break;
    }

    if (this.quantity) {

      price = price * this.quantity;

      for (let i in this.addons) {
        for (let j in this.addons[i]) {
          price = price + (this.addons[i][j].price * this.quantity)
        }
      }
    }

    return price.toFixed(2);
  }

  addOptional(e: any, add: OptionalForItemDto, cdAddon: number) {

    if (e.target.checked) {

      if (!this.addons[add.cdOptional])
        this.addons[add.cdOptional] = {}

      let index = add.addons.findIndex(a => a.cdAddon == cdAddon);

      this.addons[add.cdOptional][cdAddon] = {
        price: add.addons[index].qtPrice,
        id: cdAddon
      }

      if (Object.keys(this.addons[add.cdOptional]).length > add.nmMaximum) {

        this.presentToast(`No puede seleccionar más de ${add.nmMaximum} ${add.dsName}`);

        e.target.checked = false;

        delete this.addons[add.cdOptional][cdAddon];
      }
    }
    else
      delete this.addons[add.cdOptional][cdAddon];
  }

  public async addToCart() {

    this.loading = await this.loadingController.create({
      message: 'Añadiendo articulo al carrito...',
    });

    await this.loading.present();

    if (!this.hassSession()) {
      this.loading.dismiss();
      this.dismiss();
      return;
    }

    if (!this.localStorageService.getRestaurantData().isRealOpen) {

      await this.presentToast("El comercio está cerrado, verifique los horarios de atención");
      await this.loading.dismiss();
      await this.dismiss();
      return;
    }

    let add: ExtrasDto[] = [];

    for (let i in this.addons) {
      for (let j in this.addons[i]) {
        add.push({
          cdAddon: parseInt(j),
          cdOptional: parseInt(i),
          nmQuantity: 1
        })
      }
    }

    await this.checkAndSendCartData(add);
  }

  private async checkAndSendCartData(add: ExtrasDto[]) {

    this._cartService.apiCartGetMyCartGet(parseInt(this.localStorageService.getUserId())).subscribe(x => {

      if (this.idStore != x.cdStore) {
        this.localStorageService.clearCartNo();
        this.localStorageService.clearCartData();
      }

      const allData: AddToCartDto = {
        guidCart: this.localStorageService.getCartNo() || null,
        cdUser: parseInt(this.localStorageService.getUserId()),
        cdStore: this.idStore,
        cdItem: this.item.cdItem,
        nmQuantity: this.quantity,
        nmItemSize: parseInt(this.priceSizeSelected),
        extras: add
      };

      this._cartService.apiCartAddToCartPost(allData).subscribe(x => {

        this.presentToast('Articulo agregado');

        this.localStorageService.setCartNo(x)

        this._cartQantityService.updateCartQuantity();

        this.loading.dismiss();

        this.dismiss();
      },
        err => {
          this.presentToast(err.error.error);
          this.loading.dismiss();
        }
      );
    })
  }

  async dismiss() {
    await this.modalController.dismiss({
      'dismissed': true
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      position: 'top',
      duration: 1000,
    });

    toast.present();
  }

  hassSession() {

    if (!this.localStorageService.getUserId()) {
      this.nav.navigateForward('/login');
      return false;
    }

    return true;
  }
}
